/**
 * Extended Window interface with tutorial-specific globals
 */
export interface TutorialWindow extends Window {
  __tutorialActive?: boolean;
  __tutorialCompletedSuccessfully?: boolean;
}

/**
 * Type-safe access to tutorial-enhanced window object
 */
export function getTutorialWindow(): TutorialWindow {
  if (typeof window === 'undefined') {
    // Return a mock object for SSR contexts
    return {} as TutorialWindow;
  }
  return window as unknown as TutorialWindow;
}

/**
 * Check if tutorial is currently active
 */
export function isTutorialActive(): boolean {
  const win = getTutorialWindow();
  return win.__tutorialActive ?? false;
}

/**
 * Set tutorial active state
 */
export function setTutorialActive(active: boolean): void {
  const win = getTutorialWindow();
  win.__tutorialActive = active;
}

/**
 * Check if the tutorial completed successfully
 */
export function getTutorialCompletedSuccessfully(): boolean {
  const win = getTutorialWindow();
  return win.__tutorialCompletedSuccessfully ?? false;
}

/**
 * Mark the tutorial as completed successfully
 */
export function setTutorialCompletedSuccessfully(completed: boolean): void {
  const win = getTutorialWindow();
  win.__tutorialCompletedSuccessfully = completed;
}

/**
 * Clear all tutorial state
 */
export function clearTutorialState(): void {
  const win = getTutorialWindow();
  delete win.__tutorialActive;
  delete win.__tutorialCompletedSuccessfully;
}
